export const contains = (text: string | undefined, filter: string | undefined) => (filter ?? '').trim().length === 0 || 
(text ?? '').trim().toLowerCase().includes((filter ?? '').trim().toLowerCase());
